// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { dynamicElementsSlidingCarouselKey } from '@epicuro-next/constants/dynamic-elements';
import {
  EventHandlerPayloadResolveMoment,
  IDynamicItem,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { recommendationUrlRedirect } from '@epicuro-next/state/recommendation-panels-state';

export const slidingCarouselPanel: IDynamicItem = {
  id: 'sliding-carousel',
  contentTypeId: dynamicElementsSlidingCarouselKey,
  inputs: {
    slides: {
      property: 'slides',
      provider: 'self',
    },
    disabledRouterLink: true,
  },
  data: {
    panelName: 'sliding-carousel',
    panelStyle: 'BPM',
    servingConfig: 'SliderLandingPanel',
  },
  outputs: {
    slideRedirectClick: {
      action: recommendationUrlRedirect.type,
      type: 'ngrx',
      payloadFetchMoment:
        EventHandlerPayloadResolveMoment.BeforeAddEventListener,
      payload$: {
        values: [
          {
            provider: 'event',
            property: 'slide-item',
          },
          {
            provider: 'self',
            property: 'panelName',
          },
          {
            provider: 'self',
            property: 'panelStyle',
          },
          {
            provider: 'self',
            property: 'servingConfig',
          },
        ],

        transform: function ([
          slideItem,
          panelName,
          panelStyle,
          servingConfig,
        ]: [
          {
            routerLink: string;
          },
          string,
          string,
          string,
        ]) {
          return {
            routerLink: slideItem.routerLink,
            panelName,
            panelStyle,
            servingConfig,
          };
        }.toString(),
      },
    },
  },
};
